module.exports = __webpack_public_path__ + "static/media/facebook-comparativo.23f565a4.png";